<template>
  <button
    class="w-10 md:w-12 lg:w-14 fixed bottom-24 z-50"
    :style="{ left }"
    :class="[visible ? 'block' : 'hidden']"
    @click="backTop"
  >
    <img class="select-none" :src="require('@/assets/images/back-top.png')" />
  </button>
</template>
<script>
export default {
  name: 'BackTop',
  data() {
    return {
      visible: false,
      left: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, false);
    window.addEventListener('resize', this.onResize, false);

    this.onResize();
    this.$once('beforeDestroy', () => {
      window.removeEventListener('scroll', this.onScroll, false);
      window.removeEventListener('scroll', this.onResize, false);
    });
  },
  methods: {
    onScroll() {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      this.visible = top > 200;
    },
    onResize() {
      const mainW = 1170;
      if (window.innerWidth < 768) {
        this.left = window.innerWidth - 60 + 'px';
      } else if (window.innerWidth < 1536) {
        this.left = window.innerWidth - 100 + 'px';
      } else {
        this.left = (window.innerWidth - mainW) / 2 + mainW + 100 + 'px';
      }
    },
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
